import { render } from "./SavedStylesView.vue?vue&type=template&id=44872ce8"
import script from "./SavedStylesView.vue?vue&type=script&lang=js"
export * from "./SavedStylesView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__